const getBlockTitle = (blockName, pageData, slide) => {
  switch (blockName) {
    case 'acf/hero':
      return pageData?.heading || null;
    case 'acf/teasernew':
      return pageData?.heading || null;
    case 'core/heading':
      return pageData?.content || null;
    case 'acf/faq-most-viewed':
    case 'acf/cardlist':
      return (pageData?.title ? pageData?.title : slide) || null;
    case 'benefits':
      return pageData || null;
    case 'acf/internetrecommender':
      return 'internetrecommender';
    default:
      return pageData?.title || null;
  }
};

export default getBlockTitle;
